import axios from 'axios';

const generateInstance = (defaultConfig, onInit) => {
  const instance = axios.create(defaultConfig);

  return {
    init() {
      instance.interceptors.response.use(
        function (response) {
          return response;
        },
        function (error) {
          if (error.response) error = error.response.data;
          return Promise.reject(error);
        }
      );

      if (onInit) onInit();
    },

    setHeader() {
      const client = window.location.pathname.substring(1);
      instance.defaults.headers.common['client'] = client;
    },

    async get(url, params) {
      this.setHeader();
      return await instance.get(url, { ...params }).then((r) => r.data);
    },

    async post(url, data, config = {}) {
      this.setHeader();
      return await instance.post(url, data, config).then((r) => r.data);
    },

    async put(url, data) {
      this.setHeader();
      return await instance.put(url, data).then((r) => r.data);
    },

    async delete(url, params) {
      this.setHeader();
      return await instance.delete(url, { ...params }).then((r) => r.data);
    },
  };
};

const apiV2 = generateInstance({
  baseURL: process.env.VUE_APP_API_V2_URL,
  withCredentials: true,
});

// piggy back v2's init on v1's init
const apiV1 = generateInstance(
  {
    baseURL: '/',
  },
  () => apiV2.init()
);

export default apiV1;

export { apiV2 };
